import {ApiProtectedWS as http} from "../api/axios";
import {baseURL} from "../util/Constants";

class PriorityTypeService {

    getAll() {
        return http?.get(baseURL.readApi.priorities + `/`);
    }
}

export default PriorityTypeService;